import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageBase, IntegrationLogInfo, IntegrationLogType, EntityQueueInfo } from 't4core';
import { Router } from '@angular/router';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  styleUrls: ['./EntityLogs.css'],
  selector: 'EntityLogs',
  templateUrl: './EntityLogs.html',
})
export class EntityLogs extends PageBase implements OnInit {
  public isLoading: boolean = false;
  public onlyActive: boolean = true;
  @ViewChild("tblIntegrationLogs", { static: false }) tblIntegrationLogs: T4DatatableWidget;
  public IntegrationLogsData: IntegrationLogInfo[] = [];
  @ViewChild("tblPendingEntities", { static: false }) tblPendingEntities: T4DatatableWidget;
  public PendingEntitiesData: EntityQueueInfo[] = [];

  constructor(el: ElementRef, private router: Router) {
    super(el, "EntityLogs");
  }

  async ngOnInit() {
    await this.loadData();
  }

  public async loadData() {
    this.isLoading = true;
    this.IntegrationLogsData = await this.Api.get<IntegrationLogInfo[]>("/TurboOrder/GetIntegrationLogs", { type: IntegrationLogType.None });
    this.PendingEntitiesData = await this.Api.get<EntityQueueInfo[]>("/TurboOrder/GetPendingEntityQueues", {});
    this.isLoading = false;
  }

  public async RefreshData() {
    await this.loadData();
    this.UI.alert("TO.EntityLogs.RefreshDataPopup", "Refresh completed", "TO.EntityLogs.msgRefreshDataPopup1", "The integration logs and pending entities are updated from database.")
  }
}
